import { render, staticRenderFns } from "./general-information.vue?vue&type=template&id=29d693c6&scoped=true"
import script from "./general-information.vue?vue&type=script&lang=js"
export * from "./general-information.vue?vue&type=script&lang=js"
import style0 from "./general-information.vue?vue&type=style&index=0&id=29d693c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d693c6",
  null
  
)

export default component.exports